import { render } from "./userInputs.vue?vue&type=template&id=3f32e764&scoped=true"
import script from "./userInputs.vue?vue&type=script&lang=js"
export * from "./userInputs.vue?vue&type=script&lang=js"

import "./userInputs.vue?vue&type=style&index=0&id=3f32e764&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f32e764"]])

export default __exports__